import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { getInvestigationMetricsDocusketchRequestedQuery } from "./investigation-metrics-docusketch-requested.operations";
import { IApiInvestigationMetricsDocusketchRequestedConnection, IApiInvestigationMetricsFilter } from 'src/app/shared/modules/graphql/types/types';
import { IGqlBaseOptions } from "../../../../interfaces";
import { connectionQuery } from "../../../../helpers.class";

@Injectable()
export class GqlInvestigationMetricsDocusketchRequestedService {
  public constructor(
    private apollo: Apollo
  ) { }

  public get(filters: IApiInvestigationMetricsFilter[], options: IGqlBaseOptions): Observable<IApiInvestigationMetricsDocusketchRequestedConnection> {
    return this.apollo.query(connectionQuery(getInvestigationMetricsDocusketchRequestedQuery, filters, options)).pipe(
      safeResolve(true)
    );
  }

}
